export const REDUX_STORE_HOME = 'add_youtube_source'
